import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { IntlProvider, FormattedNumber as FormattedNumberReactIntl, injectIntl } from 'react-intl'
import _ from 'lodash'
import cx from 'classnames'

import config from '../../../../config'

import hocConnect from './hocConnect'

@injectIntl
@hocConnect
export default class FormattedNumber extends Component {
    static propTypes = {
        intl: PropTypes.object.isRequired,
        locale: PropTypes.string.isRequired,
    }

    shouldComponentUpdate() {
        return true
    }

    render() {
        const { locale, ...otherProps } = this.props

        if (locale === _.get(config, 'languages.en.key') && otherProps.style === 'currency') {
            const formattedNumber = this.props.intl.formatNumber(otherProps.value, {
                ...otherProps,
                currencyDisplay: 'code',
            })
            const { currency } = otherProps

            return (
                <span className={cx(otherProps.className)}>{`${currency} ${formattedNumber.split(currency)[1]}`}</span>
            )
        }

        const number = (
            <FormattedNumberReactIntl
                {...otherProps}
                currencyDisplay={otherProps.currency === 'CZK' ? 'symbol' : 'code'}
            />
        )

        // if locale is SK, use czech format (mainly currency)
        if (locale === _.get(config, 'languages.sk.key')) {
            return (
                <IntlProvider textComponent="span" locale={config.languages.cs.key}>
                    {number}
                </IntlProvider>
            )
        }

        return number
    }
}
